import {OTPSession, OTPSessionStatus} from '../../domain/otp/otp';
import {Injectable} from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class FrontOtpBusinessService {
    constructor() {
    }

    canEvolve(otpSession: OTPSession): boolean {
        if (otpSession) {
            switch (otpSession.status) {
                case OTPSessionStatus.OPEN:
                case OTPSessionStatus.WAIT_FOR:
                case OTPSessionStatus.WAIT_RESERVATION:
                    return true;
            }
        }

        return false;
    }
}
